// CompanyInformationForm.js
import React from "react";
import {
  Box,
  InputLabel,
  TextField,
  Divider,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  Grid,
  FormHelperText,
} from "@mui/material";
import ButtonCommon from "../../CommonComponent/ButtonCommon";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

// import 'react-phone-input-2/lib/style.css'; 
// import { MuiTelInput } from "mui-tel-input";
// import { isValidPhoneNumber } from "react-phone-number-input";

const CompanySettings = ({
  formData,
  handleInputChange,
  onBack,
  onNext,
  errors,
  hasDpo,
  setHasDpo,
}) => {
  return (
    <Paper elevation={2} sx={{ p: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <InputLabel
          htmlFor="company_name"
          required
          sx={{
            mb: 1,
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          }}
        >
          Company Name
        </InputLabel>
        <TextField
          fullWidth
          required
          id="company_name"
          name="config.introduction.company_name"
          value={formData?.config?.introduction?.company_name}
          onChange={handleInputChange}
          placeholder="My Company LTD"
          size="small"
          autoComplete="off"
          error={!!errors["config.introduction.company_name"]}
          helperText={errors["config.introduction.company_name"]}
        />

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InputLabel
              htmlFor="dpo_email"
              required
              sx={{
                mb: 1,
                mt: 2,
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Email
            </InputLabel>
            <TextField
              fullWidth
              required
              id="dpo_email"
              name="config.contact_us.contact_email"
              value={formData?.config?.contact_us?.contact_email}
              onChange={handleInputChange}
              placeholder="example@email.com"
              size="small"
              type="email"
              autoComplete="off"
              error={!!errors["config.contact_us.contact_email"]}
              helperText={errors["config.contact_us.contact_email"]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel
              htmlFor="dpo_phone"
              required
              sx={{
                mb: 1,
                mt: 2,
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              Phone Number
            </InputLabel>
            <PhoneInput
  country={'in'} // 🇮🇳 India as default
  value={formData?.config?.contact_us?.contact_phone || ''}
  onChange={(phone) =>
    handleInputChange({
      target: {
        name: 'config.contact_us.contact_phone',
        value: phone,
      },
    })
  }
  inputProps={{
    name: 'config.contact_us.contact_phone',
    required: true,
    autoComplete: 'off',
  }}
  containerStyle={{
    width: '100%',
  }}
  inputStyle={{
    width: '100%',
    fontSize: '14px',
    height: '40px',
    paddingLeft: '60px', // ✅ Prevents overlap with flag + code
    borderColor: errors['config.contact_us.contact_phone'] ? 'red' : '#ced4da',
    borderRadius: '4px',
  }}
  buttonStyle={{
    border: 'none',
    backgroundColor: 'transparent',
    padding: '0 10px',
  }}
  enableSearch={true} // ✅ Enables searchable dropdown
  enableAreaCodes={false} // ❌ Prevents showing area codes
  disableAreaCodes={true} // ✅ Disables multiple entries per country
  disableCountryCode={false}
  disableDropdown={false}
  countryCodeEditable={false}
  specialLabel=""
/>

            {errors['config.contact_us.contact_phone'] && (
              <FormHelperText error>
                {errors['config.contact_us.contact_phone']}
              </FormHelperText>
            )}

          </Grid>
        </Grid>
        <InputLabel
          htmlFor="domain_url"
          required
          sx={{
            mb: 1,
            mt: 2,
            "& .MuiFormLabel-asterisk": {
              color: "red",
            },
          }}
        >
          Company URL
        </InputLabel>
        <TextField
          onBlur={(e) => {
            let value = e.target.value.trim();
            if (value && !(value.startsWith("https://") || value.startsWith("http://"))) {
              handleInputChange({
                target: {
                  name: "config.introduction.domain_url",
                  value: value, // Don't modify the input — keep it as-is
                },
              });
            }
          }}


          fullWidth
          required
          id="domain_url"
          name="config.introduction.domain_url"
          value={formData?.config?.introduction?.domain_url}
          onChange={handleInputChange}
          placeholder="https://mycompany.com"
          size="small"
          autoComplete="off"
          error={!!errors["config.introduction.domain_url"]}
          helperText={errors["config.introduction.domain_url"]}
        />
      </Box>

      <Divider sx={{ mt: 3, mb: 3 }} />

      <FormControl margin="normal" error={!!errors["hasDpo"]}>
        <FormLabel id="dpo-label">
          Do you have a Data Protection Officer (DPO)?
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="dpo-label"
          value={hasDpo ? "true" : "false"} // Track value using hasDpo state
          onChange={(e) => {
            const value = e.target.value === "true";
            setHasDpo(value); // Update only the state, not config
            if (!value) {
              // Clear out DPO email and phone if "No" is selected
              handleInputChange({
                target: { name: "config.introduction.dpo_email", value: "" },
              });
              handleInputChange({
                target: { name: "config.introduction.dpo_phone", value: "" },
              });
            }
          }}
        >
          <FormControlLabel
            value="true"
            control={<Radio id="dpo-yes" />}
            label="Yes"
          />
          <FormControlLabel
            value="false"
            control={<Radio id="dpo-no" />}
            label="No"
          />
        </RadioGroup>
        {errors["hasDpo"] && (
          <FormHelperText>{errors["hasDpo"]}</FormHelperText>
        )}
      </FormControl>

      {hasDpo && (
        <>
          <Box sx={{ mt: 2 }}>
            <InputLabel
              htmlFor="dpo_specific_email"
              required
              sx={{
                mb: 1,
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              DPO Email Address
            </InputLabel>
            <TextField
              fullWidth
              required
              id="dpo_specific_email"
              name="config.introduction.dpo_email"
              value={formData?.config?.introduction?.dpo_email || ""}
              onChange={handleInputChange}
              placeholder="dpo@example.com"
              size="small"
              type="email"
              autoComplete="off"
              error={!!errors["config.introduction.dpo_email"]}
              helperText={errors["config.introduction.dpo_email"]}
            />
          </Box>
          <Box sx={{ mt: 2 }}>
            <InputLabel
              htmlFor="dpo_specific_phone"
              required
              sx={{
                mb: 1,
                "& .MuiFormLabel-asterisk": {
                  color: "red",
                },
              }}
            >
              DPO Phone
            </InputLabel>
            <TextField
              fullWidth
              required
              id="dpo_specific_phone"
              name="config.introduction.dpo_phone"
              value={formData?.config?.introduction?.dpo_phone || ""}
              onChange={handleInputChange}
              placeholder="0638886523"
              size="small"
              type="tel"
              autoComplete="off"
              error={!!errors["config.introduction.dpo_phone"]}
              helperText={errors["config.introduction.dpo_phone"]}
              inputProps={{
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Removes non-numeric characters
              }}
            />
          </Box>
        </>
      )}

      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <ButtonCommon sx={{ borderColor: "lightgray" }} onClick={onBack}>
          Back
        </ButtonCommon>
        <ButtonCommon onClick={onNext}>Next</ButtonCommon>
      </Box>
    </Paper>
  );
};

export default CompanySettings;
